import { RhinoRecordIdentifier, RhinoResource } from '../index';

export const getRootPath = () => '/';

export const getAuthenticatedAppPath = () => '/main';
export const getNonAuthenticatedAppPath = () => '/auth';

export const getSessionCreatePath = () => 'signin';

export const getUserCreatePath = () => 'signup';

export const getForgotPasswordPath = () => 'forgot-password';

export const getSettingsPath = () => 'settings';

export const getAccountSettingsPath = () => 'account/settings';

export const getModelIndexPath = (model: RhinoResource) =>
  `${model.pluralName}`;

export const getModelShowPath = (
  model: RhinoResource,
  id: RhinoRecordIdentifier
) => `${model.pluralName}/${id}`;

export const getModelCreatePath = (model: RhinoResource) =>
  `${model.pluralName}/new`;

export const getModelEditPath = (
  model: RhinoResource,
  id: RhinoRecordIdentifier
) => `${model.pluralName}/${id}/edit`;
